import React from "react";
import PropTypes from "prop-types";
import "./EndScreen.scss";

const EndScreen = ({ question }) => {
  return (
    <div className="end-screen">
      {question.title && (
        <h2 className="end-screen__title">{question.title}</h2>
      )}
      {question.description && (
        <div className="end-screen__description">
          <p>{question.description}</p>
        </div>
      )}
    </div>
  );
};

EndScreen.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default EndScreen;
